<template>
    <div class="container_layout">
        <el-row class="guide_title">
            <el-col v-show="targetTypeId===1" :span="16" :offset="4">請選擇性別年齡？</el-col>
            <el-col v-show="targetTypeId===2" :span="16" :offset="4">請選擇熱門產業受眾？</el-col>
            <el-col v-show="targetTypeId===3" :span="16" :offset="4">請選擇特定族群？</el-col>
        </el-row>
        <optionNotFoundFeedback
          v-if="isNotChooseGenderAge"
          :visible.sync="dialogVisible"
          :title="disloagTitle"
          :emailTitle="emailTitle"
        />
        <el-row :gutter="24" style="">
            <RadioGroup
                :optionType="2"
                :delay="50"
                animation=""
                :items="items"
                :activatedId="activatedId"
                :showInfo="{txt:''}"
                @change="updateSelectedItem"
                :toggleMouseInOutMethod="isChooseGroupBySpecificGroup ? true : false"
                @hoverItem="fadeInSuggestion"
                @leaveItem="fadeoutSuggestion"
            ></RadioGroup>
        </el-row>
        <el-row v-if="targetTypeId===2 || targetTypeId===3">
          <el-col style="text-align: center;">
              <span @click="dialogVisible = true" style="color:#4da1ff; cursor: pointer;">
                {{ notFoundText }}
              </span>
          </el-col>
        </el-row>
        <!-- 性別年齡 -->
        <el-row  v-show="targetTypeId===1">
            <el-col :xs="2" :sm="3" :md="3">
                &nbsp; <!-- RWD offset -->
            </el-col>
            <el-col :xs="20" :sm="18" :md="18">
                <el-row :gutter="24">
                    <sequential-entrance delay="" >
                        <AgePicker
                            :init-lower-bound="ageRange[0]"
                            :init-upper-bound="ageRange[1]"
                            @change="updateAgeRange"
                        ></AgePicker>
                    </sequential-entrance>
                </el-row>
            </el-col>
        </el-row>

        <fragment v-if="isPurposePath">
            <el-row class="guide_title" style="margin-top:100px;">
                <sequential-entrance delay="" fromBottom>
                    <el-col :span="16" :offset="4">
                      <div id='reach' style="display: inline-flex">
                        <span>請選擇目標觸及率(Reach%)？</span>
                        <Suggestion>
                            <template #suggestContent>
                              <p style="padding: 10px;margin: 0px;">建議至少觸及50%的目標受眾<br>以達到有效益的傳播規模</p>
                            </template>
                          </Suggestion>
                      </div>
                    </el-col>
                </sequential-entrance>
            </el-row>

            <el-row style="margin-top:40px;text-align:center;">
                <el-col  :span="16" :offset="4">
                <el-input-number v-model="reachRate" :min="10" :max="100" :step="10" label="描述文字"></el-input-number>
                </el-col>
            </el-row>
        </fragment>
        <div style="height: 300px"></div>
        <!-- 特定族群輔助說明 -->
        <div v-if="isChooseGroupBySpecificGroup && targetDescription !== ''"
          :class="{ fadeIn: suggestionFadeIn, fadeOut: suggestionFadeOut }"
          class="specific-group-suggestion"
          v-html="targetDescription"
        >
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { GUIDE_MUTATIONS } from '../../../store/modules/guide'
import { PATH_TYPE } from '../Const'
import RadioGroup from '../components/RadioGroup'
import AgePicker from '../components/AgePicker'
import optionNotFoundFeedback from '../optionNotFoundFeedback'
import Suggestion from '@/views/Suggestion'
// 特定族群的描述文字做斷行
const textnNewline = (text) => {
  const newlinechars = ['，', '。', '、']
  if (text.length >= 45) {
    for (var i = 45; i > 0; i--) {
      if (newlinechars.includes(text[i])) {
        return text.substring(0, i + 1) + '<br>' + text.substring(i + 1, text.length)
      }
    }
  }
  return text
}

export default {
  name: 'step3',
  components: { Suggestion, RadioGroup, AgePicker, optionNotFoundFeedback },
  props: ['path'],
  data () {
    return {
      dialogVisible: false,
      targetDescription: '',
      suggestionFadeIn: false, // 特定族群輔助說明是否 fadeIn
      suggestionFadeOut: false, // 特定族群輔助說明是否 fadeOut
      descriptions: [],
      hasScrollToReachComponent: false
    }
  },
  computed: {
    ...mapState({
      pathSpecificState (state) {
        return state.guide[this.path]
      },
      optionDataFromStore (state) {
        const filteredArr = state.guide.root.optionData.targetCategory.filter((el) => {
          return el.id === this.targetTypeId
        })
        if (filteredArr && filteredArr[0]) {
          return filteredArr[0].targets
        } else {
          return []
        }
      },
      items () {
        if (this.isChooseGroupByGenderAge) {
          // 性別年齡需要另外處理
          return [
            { id: 1, name: '男性', icon: 'fas fa-mars' },
            { id: 2, name: '女性', icon: 'fas fa-venus' },
            { id: 3, name: '全部', icon: 'fas fa-venus-mars' }
          ]
        } else {
          return this.optionDataFromStore
        }
      }
    }),
    isPurposePath () {
      return this.path === PATH_TYPE.PURPOSE
    },
    targetTypeId () {
      return this.pathSpecificState.targetType.id
    },
    targetOptionId () {
      return this.pathSpecificState.targetOption.id
    },
    isNotChooseGenderAge () {
      return !this.isChooseGroupByGenderAge
    },
    activatedId () {
      if (this.isChooseGroupByGenderAge) {
        return this.pathSpecificState.genderId
      } else {
        return this.targetOptionId
      }
    },
    ageRange () {
      return this.pathSpecificState.ageRange
    },
    notFoundText () {
      if (this.isChooseGroupByHotIndustry) {
        return '找不到您要的產業?'
      } else if (this.isChooseGroupBySpecificGroup) {
        return '找不到您要的族群?'
      }
      return ''
    },
    disloagTitle () {
      if (this.isChooseGroupByHotIndustry) {
        return '請填寫您的產業'
      } else if (this.isChooseGroupBySpecificGroup) {
        return '請填寫您的族群'
      }
      return ''
    },
    emailTitle () {
      if (this.isChooseGroupByHotIndustry) {
        return '找不到產業'
      } else if (this.isChooseGroupBySpecificGroup) {
        return '找不到族群'
      }
      return ''
    },
    reachRate: {
      get () {
        return this.$store.state.guide.purpose.reachRate
      },
      set (val) {
        this.$store.commit(GUIDE_MUTATIONS.PURPOSE.UPDATE_REACH_RATE, val)
      }
    },
    genderAgeOptionName () {
      let genderPostFixStr
      switch (this.activatedId) {
        case 1:
          genderPostFixStr = 'M'
          break
        case 2:
          genderPostFixStr = 'F'
          break
        default:
          genderPostFixStr = ''
          break
      }

      if (this.ageRange.length === 2) {
        return `${this.ageRange[0]}-${this.ageRange[1]}${genderPostFixStr}`
      } else {
        return ''
      }
    },
    isChooseGroupByGenderAge () {
      return this.targetTypeId === 1
    },
    isChooseGroupByHotIndustry () {
      return this.targetTypeId === 2
    },
    isChooseGroupBySpecificGroup () {
      return this.targetTypeId === 3
    }
  },
  created () {
    this.setDescriptions()
  },
  methods: {
    // 設定特定族群的輔助說明
    setDescriptions () {
      if (this.isChooseGroupBySpecificGroup) {
        let targets = this.$lodash.cloneDeep(this.optionDataFromStore)
        targets.forEach(target => {
          target.description = textnNewline(target.description)
        })
        this.descriptions = targets
      }
    },
    updateSelectedItem (data) {
      if (this.targetTypeId !== 1) {
        this.updateTargetOption(data)
      } else {
        this.updateGender(data)
      }
    },
    updateGender ({ id }) {
      if (this.isPurposePath) {
        this.$store.commit(GUIDE_MUTATIONS.PURPOSE.SET_GENDER_ID, id)
      } else {
        this.$store.commit(GUIDE_MUTATIONS.AUDIENCE.SET_GENDER_ID, id)
      }
      this.updateGenderAndAge()
    },
    updateAgeRange (ageRangeArr) {
      if (this.isPurposePath) {
        this.$store.commit(GUIDE_MUTATIONS.PURPOSE.SET_AGE_RANGE, ageRangeArr)
      } else {
        this.$store.commit(GUIDE_MUTATIONS.AUDIENCE.SET_AGE_RANGE, ageRangeArr)
      }
      this.updateGenderAndAge()
    },
    updateGenderAndAge () {
      const optionArr = this.optionDataFromStore.filter((el) => {
        return el.name === this.genderAgeOptionName
      })
      const result = this.$lodash.isEmpty(optionArr) ? { id: -1 } : optionArr[0]
      this.updateTargetOption(result)
    },
    updateTargetOption (data) {
      if (this.path === PATH_TYPE.PURPOSE) {
        this.$store.commit(GUIDE_MUTATIONS.PURPOSE.SET_TARGET_OPTION, data)
      } else {
        this.$store.commit(GUIDE_MUTATIONS.AUDIENCE.SET_TARGET_OPTION, data)
      }

      if (!this.hasScrollToReachComponent) {
        this.hasScrollToReachComponent = true
        this.smoothScroll('reach')
      }
    },
    // 特定族群的描述文字
    getTargetDescription (targetId) {
      if (!targetId) return ''
      if (this.descriptions.length <= 0) return ''
      const foundTarget = this.descriptions.find(target => target.id === targetId)
      if (foundTarget) {
        return foundTarget.description
      } else {
        return ''
      }
    },
    fadeInSuggestion (targetId) {
      this.suggestionFadeIn = true
      this.suggestionFadeOut = false
      this.targetDescription = this.getTargetDescription(targetId)
    },
    fadeoutSuggestion () {
      this.suggestionFadeIn = false
      this.suggestionFadeOut = true
    },
    smoothScroll (elementId) {
      const getTargetY = (targetElementId, scrollContainer) => {
        let result = 0
        let target = document.getElementById(targetElementId)
        while (target && target !== scrollContainer) {
          result += target.offsetTop
          target = target.offsetParent
        }
        return result
      }

      const scrollContainer = this.$el.parentElement
      const MIN_PIXELS_PER_STEP = 2
      const MAX_SCROLL_STEPS = 36
      let targetY = getTargetY(elementId, scrollContainer)
      const DIRECTION = +(targetY > scrollContainer.scrollTop)
      const CURRENT_PIXELS_PER_STEP = Math.ceil(Math.max(MIN_PIXELS_PER_STEP, Math.abs(targetY - scrollContainer.scrollTop) / MAX_SCROLL_STEPS))

      const stepFunc = function (lastDistance = 0) {
        const offsetToMakeCheckboxLower = document.body.clientHeight * 0.7
        const distance = (targetY - scrollContainer.scrollTop - offsetToMakeCheckboxLower) * DIRECTION
        if (distance > 0 && distance !== lastDistance) {
          scrollContainer.scrollTop = Math.min(targetY, scrollContainer.scrollTop + CURRENT_PIXELS_PER_STEP * DIRECTION)
          window.requestAnimationFrame(() => {
            stepFunc(distance)
          })
        }
      }
      window.requestAnimationFrame(stepFunc)
    }
  }
}
</script>
<style scoped>
    .el-input_inner.guide_input{
        text-align: center;
        background: transparent;
        border-width: 0 0 1px 0;
        border-radius: 0;
        font-size: 24px;
    }
    .guide_select.el-select{
        width:100%;
    }
    .guide_select.el-select .el-input__inner{
        height:80px;
        text-align:center;
        display:flex;
        align-items: center;
        border:2px solid #fff;
        background-color: #ffffff;
        box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
        font-size:16px;
        margin-top:64px;

    }
    .guide_select.el-select .el-input .el-select__caret{
        font-size:24px;
        margin-right: 16px;
    }
    .guide_select_text{
        margin-top: 64px;
        text-align:center;
        display:block;
        height:80px;
        line-height:80px;
    }
    @-webkit-keyframes fadeIn {
      0% {opacity: 0;}
      100% {opacity: 1;}
    }
    @-webkit-keyframes fadeOut {
      0% {opacity: 1;}
      100% {opacity: 0;}
    }
    @keyframes fadeIn {
      0% {opacity: 0;}
      100% {opacity: 1;}
    }
    @keyframes fadeOut {
      0% {opacity: 1;}
      100% {opacity: 0;}
    }
    .specific-group-suggestion {
      display: block;
      text-align: center;
      position:absolute;
      bottom:24px;
      left: 50%;
      margin-left: -384px;
      background-image: radial-gradient(farthest-corner at 50% 149%, rgba(132,190,255,0.25) 50%, rgba(255,255,255,0.40) 100%);
      line-height: 1.5;
      width:768px;
      padding:8px 0;
      font-size:14px;
      color: #4a4a4a;
    }
    .fadeIn {
      animation-name: 'fadeIn';
      animation-duration: 250ms;
      animation-fill-mode: both;
    }
    .fadeOut {
      animation-name: 'fadeOut';
      animation-duration: 250ms;
      animation-fill-mode: both;

    }
</style>
